import { Link } from '~/components/Link'

export function Button({
  className,
  disabled,
  onClick,
  children,
  paddingClass,
  to,
  type,
}: {
  className?: string
  disabled?: boolean
  onClick?: () => void
  to?: string
  children: React.ReactElement | string
  paddingClass?: string
  type?: 'button' | 'submit' | 'reset'
}): React.ReactElement {
  const padding = paddingClass || 'px-12 py-3'
  const baseClass = `text-center mt-4 block rounded bg-purple text-md text-white hover:bg-purple-dark ${padding}`
  const disabledClass = 'disabled:opacity-75 disabled:cursor-not-allowed disabled:bg-purple'
  const joinedClassNames = `${baseClass} ${disabledClass} ${className}`

  if (to) {
    return (
      <Link className={joinedClassNames} disabled={disabled} onClick={onClick} to={to}>
        {children}
      </Link>
    )
  }

  return (
    <button className={joinedClassNames} disabled={disabled} onClick={onClick} type={type}>
      {children}
    </button>
  )
}
